/**
 * Pet food nutrient row ids: persisted ProductVendorNutrition row ids from the API
 * vs. client-only placeholders that must not be sent to `saveNutrient`.
 */
export function isClientOnlyPetFoodNutrientId(id: unknown): boolean {
    if (id == null || String(id).trim() === "") return true;
    const s = String(id);
    return (
        s.startsWith("temp-") || s.startsWith("default-") || s.startsWith("display-")
    );
}

/**
 * Returns the `id` to send in POST /ProductVendorNutrition/saveNutrient, or `undefined` to omit (create).
 * Client-only and empty ids are never returned.
 */
export function toSavePayloadNutrientId(
    id: string | number | null | undefined
): string | number | undefined {
    if (isClientOnlyPetFoodNutrientId(id) || id == null || String(id).trim() === "") {
        return undefined;
    }
    const s = String(id).trim();
    const n = Number(s);
    if (!Number.isNaN(n) && Number.isFinite(n) && s === String(n)) {
        return n;
    }
    return s;
}
